import { BlockPropsBase } from "../..";

export default (props: BlockPropsBase): JSX.Element => null;
